import { render } from "./PaletteCard.vue?vue&type=template&id=0b64014f&scoped=true"
import script from "./PaletteCard.vue?vue&type=script&lang=js"
export * from "./PaletteCard.vue?vue&type=script&lang=js"

import "./PaletteCard.vue?vue&type=style&index=0&id=0b64014f&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b64014f"]])

export default __exports__